// Direct fix for calculator cart quantity issues
document.addEventListener('DOMContentLoaded', function () {
  console.log("=== CALCULATOR CART FIX LOADED ===");

  // Constants
  const FALLBACK_VARIANT_IDS = ["55795499139459", "56535863787907"]; // Glass + Brick price-unit IDs
  const CUSTOM_PRODUCT_HANDLE = "custom-charge-unit";
  const CALCULATOR_VARIANT_ID = "55795499139459"; // Prevent ReferenceError

  // Function to directly update the cart table
  function updateCartTableQuantities() {
    console.log("Updating cart table quantities");

    // Find the cart table
    const cartTable = document.querySelector('table.data-table.full.cart-table');
    if (!cartTable) {
      console.log("Cart table not found");
      return;
    }

    // Use throttled cart from simplePool if available
    const getCart = (typeof simplePool !== 'undefined' && simplePool.getThrottledCart)
      ? simplePool.getThrottledCart.bind(simplePool)
      : () => fetch('/cart.js').then(res => res.json());

    getCart()
      .then(cart => {
        console.log("Cart data fetched:", cart);

        // Get all rows in the cart table
        const cartRows = cartTable.querySelectorAll('tbody tr');
        console.log("Cart rows found:", cartRows.length);

        // Create a map of line items for easy lookup
        const lineItemMap = {};
        cart.items.forEach(item => {
          lineItemMap[item.key] = item;
        });

        // Process each row
        cartRows.forEach(row => {
          // Skip if already processed
          if (row.hasAttribute('data-calculator-processed')) {
            return;
          }

          // Find the line item key for this row
          const qtyInput = row.querySelector('input[id^="updates_"]');
          if (!qtyInput) return;

          const keyMatch = qtyInput.name.match(/updates\[(.*?)\]/);
          if (!keyMatch || !keyMatch[1]) return;

          const lineKey = keyMatch[1];
          const item = lineItemMap[lineKey];

          if (!item) {
            console.log("No matching item found for key:", lineKey);
            return;
          }

          console.log("Processing row for item:", item.title);

          // Check if this is a calculator item
          if (FALLBACK_VARIANT_IDS.includes(item.variant_id.toString()) ||
            item.variant_id.toString() === CALCULATOR_VARIANT_ID ||
            item.product_handle === CUSTOM_PRODUCT_HANDLE ||
            (item.properties && (item.properties['_Product Title'] === 'Custom Cut Stove Glass' || item.properties['_Product Title'] === 'Custom Cut Brick'))) {

            console.log("Found calculator item:", item);

            // Get the actual quantity from properties (check both visible and hidden property)
            const actualQuantity = parseInt(item.properties.Quantity || item.properties._Quantity || 1);
            console.log("Actual quantity from properties:", actualQuantity);

            // NOTE: never rewrite qtyInput.value here. The cart form submits
            // updates[] positionally, so writing _Quantity (1/2) into the input
            // would collapse penny-fallback lines (e.g. 3296 x £0.01) to £0.01 x1
            // on the next Update/checkout submit. Server-rendered Liquid in
            // snippets/cart-template.liquid now handles calculator-line display.

            // Make the visible input read-only
            if (!qtyInput.hasAttribute('readonly')) {
              qtyInput.setAttribute('readonly', 'readonly');
              qtyInput.style.pointerEvents = 'none';
            }

            // Disable the +/- buttons if they exist
            const minusButton = row.querySelector('.reduced.items');
            const plusButton = row.querySelector('.increase.items');

            if (minusButton && minusButton.style.pointerEvents !== 'none') {
              minusButton.style.pointerEvents = 'none';
              minusButton.style.opacity = '0.5';
            }

            if (plusButton && plusButton.style.pointerEvents !== 'none') {
              plusButton.style.pointerEvents = 'none';
              plusButton.style.opacity = '0.5';
            }

            // Update the product title to show quantity if > 1
            const titleElement = row.querySelector('h5.product-name');
            if (titleElement && actualQuantity > 1) {
              const qtyIndicator = `(Qty: ${actualQuantity})`;
              if (!titleElement.textContent.includes(qtyIndicator)) {
                let titleText = titleElement.textContent.replace(/\s*\(Qty: \d+\)/, '');
                titleElement.textContent = `${titleText} ${qtyIndicator}`;
              }
            }

            // Mark this row as processed
            row.setAttribute('data-calculator-processed', 'true');
            row.setAttribute('data-actual-quantity', actualQuantity);
          }
        });
      })
      .catch(error => console.error("Error fetching cart:", error));
  }

  // Function to update mini-cart quantities
  function updateMiniCartQuantities() {
    console.log("Updating mini-cart quantities");

    // Check if we're on the checkout page
    if (window.location.pathname.includes('/checkout')) {
      console.log("On checkout page, skipping mini-cart update");
      return;
    }

    // Use throttled cart from simplePool if available
    const getCart = (typeof simplePool !== 'undefined' && simplePool.getThrottledCart)
      ? simplePool.getThrottledCart.bind(simplePool)
      : () => fetch('/cart.js').then(res => res.json());

    getCart()
      .then(cart => {
        // Calculate real item count. Discount splits share one variant across
        // several lines, each carrying the order-wide _Quantity: count the
        // human total once per variant group (see mini-cart-quantity-fix).
        const variantGroups = {};
        cart.items.forEach(item => {
          const k = item.variant_id.toString();
          (variantGroups[k] = variantGroups[k] || []).push(item);
        });

        let realItemCount = 0;

        cart.items.forEach(item => {
          if (item.variant_id.toString() === CALCULATOR_VARIANT_ID ||
            item.product_handle === CUSTOM_PRODUCT_HANDLE ||
            (item.properties && item.properties['_Product Title'])) {
            const group = variantGroups[item.variant_id.toString()] || [item];
            if (group.length > 1) {
              if (group[0] === item) {
                const hTotal = parseInt(group[0].properties.Quantity || group[0].properties._Quantity || 0, 10);
                realItemCount += hTotal > 0 ? hTotal : group.reduce((s, it) => s + (parseInt(it.quantity, 10) || 0), 0);
              }
            } else {
              realItemCount += parseInt(item.properties.Quantity || item.properties._Quantity || item.quantity || 1);
            }
          } else {
            realItemCount += item.quantity;
          }
        });

        console.log("Real item count:", realItemCount);

        // Update all mini-cart quantity displays
        const miniCartQuantities = document.querySelectorAll('.mini-cart .cart-qty, .header-cart .cart-qty, .cart-count, .mini-cart-count, [class*="cart-count"], [class*="cart-qty"]');
        miniCartQuantities.forEach(el => {
          // Only update if the value is different to avoid unnecessary DOM updates
          if (el.textContent !== realItemCount.toString()) {
            el.textContent = realItemCount;
          }
        });

        // Update cart total displays
        const cartTotals = document.querySelectorAll('.cart-total-items, .total-items');
        cartTotals.forEach(total => {
          if (total.textContent.includes('item')) {
            const newText = `${realItemCount} item${realItemCount !== 1 ? 's' : ''}`;
            if (total.textContent !== newText) {
              total.textContent = newText;
            }
          }
        });

        // Update mini-cart items
        const miniCartItems = document.querySelectorAll('.cart-wrapper .item-cart, .widget-shopping-cart .item-cart');

        // Create a map of cart items by variant ID for faster lookup.
        // Split lines share one variant: consume in drawer order so row N
        // pairs with line N (same fix as mini-cart-quantity-fix).
        const cartItemsByVariant = {};
        cart.items.forEach(item => {
          if (!cartItemsByVariant[item.variant_id]) {
            cartItemsByVariant[item.variant_id] = [];
          }
          cartItemsByVariant[item.variant_id].push(item);
        });
        const variantUseCount = {};

        miniCartItems.forEach(cartItem => {
          // Skip if this item has already been processed
          if (cartItem.hasAttribute('data-calculator-processed')) {
            return;
          }

          // Try to find the variant ID from the cart item HTML
          const variantIdMatch = cartItem.innerHTML.match(/variant=(\d+)/);
          if (!variantIdMatch) return;

          const variantId = variantIdMatch[1];

          // Find the matching cart item
          if (!cartItemsByVariant[variantId] || cartItemsByVariant[variantId].length === 0) return;

          const used = variantUseCount[variantId] || 0;
          const variantLines = cartItemsByVariant[variantId];
          const item = variantLines[Math.min(used, variantLines.length - 1)];
          variantUseCount[variantId] = used + 1;

          // Check if this is a calculator item
          if (typeof CALCULATOR_VARIANT_ID !== 'undefined' && (item.variant_id.toString() === CALCULATOR_VARIANT_ID ||
            item.product_handle === CUSTOM_PRODUCT_HANDLE ||
            (item.properties && (item.properties['_Product Title'] === 'Custom Cut Stove Glass' || item.properties['_Product Title'] === 'Custom Cut Brick')))) {

            // Split lines share the order-wide _Quantity: show the line's own
            // human share (lineQty x orderQty / groupQty), not N x unit/N.
            let actualQuantity;
            if (variantLines.length > 1) {
              const gQty = variantLines.reduce((s, it) => s + (parseInt(it.quantity, 10) || 0), 0);
              const hTotal = parseInt((item.properties || {}).Quantity || (item.properties || {})._Quantity || 0, 10);
              const lineQty = parseInt(item.quantity, 10) || 0;
              actualQuantity = (gQty > 0 && hTotal > 0) ? Math.max(1, Math.round(lineQty * hTotal / gQty)) : (lineQty || 1);
            } else {
              actualQuantity = parseInt(item.properties.Quantity || item.properties._Quantity || 1);
            }

            // Update the price display
            const priceElement = cartItem.querySelector('.price');
            if (priceElement) {
              const totalLinePrice = item.line_price;
              const unitPrice = totalLinePrice / actualQuantity;

              const formattedUnitPrice = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP'
              }).format(unitPrice / 100);

              const newHtml = `${actualQuantity} \xD7 <span class="amount"><span class="money">${formattedUnitPrice}</span></span>`;
              if (priceElement.innerHTML !== newHtml) {
                priceElement.innerHTML = newHtml;
              }
            }

            // Update the title
            const titleElement = cartItem.querySelector('.product-name');
            if (titleElement && actualQuantity > 1) {
              const qtyIndicator = `(Qty: ${actualQuantity})`;
              if (!titleElement.textContent.includes(qtyIndicator)) {
                let titleText = titleElement.textContent.replace(/\s*\(Qty: \d+\)/, '');
                titleElement.textContent = `${titleText} ${qtyIndicator}`;
              }
            }

            // Mark as processed
            cartItem.setAttribute('data-calculator-processed', 'true');
          }
        });
      })
      .catch(error => console.error("Error updating mini-cart:", error));
  }

  // Flag to prevent multiple simultaneous updates
  let isUpdating = false;
  let updateCount = 0;
  const MAX_UPDATES = 5; // Maximum number of updates to perform

  // Function to safely run updates
  function safeRunUpdates() {
    if (isUpdating) return;

    // Check if we've reached the maximum number of updates
    if (updateCount >= MAX_UPDATES) {
      console.log(`Maximum updates (${MAX_UPDATES}) reached, stopping automatic updates`);
      return;
    }

    isUpdating = true;
    updateCount++;

    console.log(`Running update ${updateCount}/${MAX_UPDATES}`);

    updateCartTableQuantities();
    updateMiniCartQuantities();

    // Reset the flag after a delay
    setTimeout(() => {
      isUpdating = false;
    }, 2000);
  }

  // Reset update count when the page is interacted with
  document.addEventListener('click', function () {
    updateCount = 0;
  });

  // Run on page load
  setTimeout(safeRunUpdates, 1000);

  // Run when cart is updated
  document.addEventListener('cart:updated', function () {
    // Reset update count for explicit cart updates
    updateCount = 0;
    setTimeout(safeRunUpdates, 500);
  });

  // Use a heavily debounced version of the observer to prevent too many updates
  let observerTimeout;
  const observer = new MutationObserver(function (mutations) {
    // Clear any existing timeout
    if (observerTimeout) {
      clearTimeout(observerTimeout);
    }

    // Set a new timeout with a longer delay
    observerTimeout = setTimeout(() => {
      let shouldUpdate = false;

      for (const mutation of mutations) {
        if (mutation.target.closest('.cart-table, #cart, .cart-form, .mini-cart, .header-cart')) {
          shouldUpdate = true;
          break;
        }
      }

      if (shouldUpdate && updateCount < MAX_UPDATES) {
        safeRunUpdates();
      }
    }, 1000);
  });

  // Start observing
  const cartContainers = document.querySelectorAll('.cart-table, #cart, .cart-form, .mini-cart, .header-cart');
  cartContainers.forEach(container => {
    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    }
  });
});
